import jQuery from "jquery";
import "jquery-validation";
import {App} from "./app/app";

import "js-datepicker";
import "./misc/datefield";

console.log("Loading main.ts", jQuery);

function init() {

    // @ts-ignore
    window.wrb_git = window.wrb_git || {
        "version":"dev",
        "branch":"dev",
        "commit":"?"
    };

    console.log("INIT");

    const app = new App();
    app.render();
}

// @ts-ignore
jQuery(init);


console.log("========================");
console.log("Service worker registration...");
if ("serviceWorker" in navigator) {
    /*
    window.addEventListener("load", function () {
        navigator.serviceWorker.register("serviceworker.js").then(function (registration) {
            console.log("ServiceWorker registration successful with scope: ", registration.scope)
        }).catch(function (err) {
            console.log("ServiceWorker registration failed: ", err)
        })
    })
     */
} else {
    console.log("Service workers are not supported.")
}
console.log("========================");
